import { Toolbar, ToolbarParentMenu } from "../model/internal/toolbar";
import { AssetStyleInfo } from "../model/internal/assetInfo";

// There is one element for each menu item in the drawing tool pallette.
export function getSelectedToolDefault(): number[] {
  return [0, 0, 0, 0, 0, 0, 0];
}

export function getSelectedTool(selectItemIndex: number): number[] {
  return [selectItemIndex, 0, 0, 0, 0, 0, 0];
}

export function getSelectedMenuItem(
  parentMenu: ToolbarParentMenu,
  itemIndex: number,
): AssetStyleInfo {
  if (parentMenu.topLevelItem !== undefined && parentMenu.topLevelItem !== null)
    return parentMenu.topLevelItem;
  return parentMenu.items[itemIndex];
}

export function getCategoryIndex(toolbar: Toolbar, className: string): number {
  return toolbar.findIndex(
    (menu) => menu.topLevelItem?.class === className || getMenuItemIndex(menu, className) >= 0,
  );
}

export function getMenuItemIndex(menu: ToolbarParentMenu, className: string): number {
  return menu.items.findIndex((item) => item.class === className);
}
